import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useExpertChat } from '../../contexts/ExpertChatContext';
import { useAuth } from '../../contexts/AuthContext';
import { useSubscription } from '../../contexts/SubscriptionContext';

const ChatButton: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const { tier } = useSubscription();
  const { isDrawerOpen, openDrawer, closeDrawer } = useExpertChat();

  if (!isAuthenticated) return null;

  const isFree = tier === 'free';
  // trial_messages_remaining is a session-level field on the user object, not subscription state
  const userData = user as Record<string, unknown> | null;
  const trialRemaining = typeof userData?.trial_messages_remaining === 'number'
    ? userData.trial_messages_remaining
    : undefined;

  return (
    <button
      onClick={isDrawerOpen ? closeDrawer : openDrawer}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-teal-500 hover:bg-teal-400 rounded-full flex items-center justify-center shadow-lg shadow-teal-500/20 transition-all duration-200 hover:scale-105"
      title="Expert Chat"
    >
      <MessageCircle size={24} className="text-white" />
      {isFree && trialRemaining != null && trialRemaining > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-amber-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
          {trialRemaining}
        </span>
      )}
    </button>
  );
};

export default ChatButton;
